<template>
  <div>
    <div
      :class="className"
      :id="id"
      :style="{ height: height, width: width }"
    />
  </div>
</template>

<script>
// import resize from "./mixins/resize";

export default {
  name: "dianxingcesuopinglun",
  // mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    id: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "200px"
    },
    height: {
      type: String,
      default: "200px"
    },
    chartData: {
      type: Object
    },
    colorPairs: {
      type: Array,
      default() {
        return ['#1283e3', '#00d1e6']
      }
    }
  },
  data() {
    return {
      chart: null,
      option: null,
      curtab: 0
    };
  },
  mounted() {
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      /*     var series = [];

             let temp = {
               // name: this.chartData.barData.legend,
                 name: "声量",

                 type: "bar",
               data: this.chartData.barData.valueList,
               markLine: {
                 symbol: "none",
                 lineStyle: {
                   normal: {
                     opacity: 0.7
                   }
                 },
                 data: [
                   {
                     yAxis: 50
                   }
                 ]
               },
               itemStyle: {
                 normal: {
                   color: "#3972ff"
                 }
               },
               barWidth: 10
             };
             series.push(temp);

             let tempLine = {
               // name: this.chartData.lineData.legend,
                 name: "好评率",
                 type: "line",
               yAxisIndex: 1,
               data: this.chartData.lineData.valueList,
               // symbol: "none",
               itemStyle: {
                 normal: {
                   color: "#38b5f3"
                 }
               },
               lineStyle: {
                 normal: {
                   color: "#38b5f3",
                   width: 2
                 }
               }
             };
             series.push(tempLine);*/
      this.option = {
        /* title: {
              text: '近一年厕所声量及好评率'
          },*/
        grid: {
          top: "16%",
          bottom: "0%",
          left: 5,
          right: 5,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          // triggerOn: "none",
          confine: true,
          textStyle: {
            color: "#cbeeff"
          },
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          }
        },
        toolbox: {
          // feature: {
          //   magicType: { show: true, type: ['line', 'bar'] },
          //   restore: { show: true }
          // }
        },
        legend: {
          left: "center",
            top:"top",

            data: this.chartData.legendList,
          icon: "rect",
            bottom:"auto",
            // left: "8%",
          // top: "5%",
           itemGap: 5,
          itemWidth: 12,
          itemHeight: 12,
          textStyle: {
            fontSize: 12,
            color: "#cbeeff"
          }
        },
        xAxis: [
          {
            type: "category",
            data: this.chartData.nameList,
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              lineStyle: {
                color: "#132847"
              }
            },
            axisLabel: {
              color: "#cbeeff",
              interval: 0,
              rotate: 40,
              textStyle: {
                fontSize: 10
              }
            },
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "声量",
              nameTextStyle: {
                  color: "#cbeeff"
              },
            // min: 0,
            // max: 1000,
            // interval: 100,
            axisLabel: {
              color: "#cbeeff",
              formatter: "{value}",
              textStyle: {
                fontSize: 10
              }
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          },
          {
            type: "value",
            name: "好评率",
              nameTextStyle: {
                  color: "#cbeeff"
              },
            // min: 0,
            // max: 25,
            // interval: 5,
            splitLine: {
              show: false
            },
            axisLabel: {
              color: "#cbeeff",
              formatter: "{value}",
              textStyle: {
                fontSize: 10
              }
            }
          }
        ],
        // series: series

        series: [
          {
            name: "声量",
            type: "bar",
            data: this.chartData.barData.valueList,
            markLine: {
              symbol: "none",
              lineStyle: {
                normal: {
                  opacity: 0.7
                }
              },
              data: [
                {
                  yAxis: 50
                }
              ]
            },
            itemStyle: {
              normal: {
                opacity: 0.8,
                color: {
                  type: 'linear',
                  x: 1,
                  y: 1,
                  x2: 0,
                  y2: 0,
                  colorStops: [
                    {
                      offset: 0,
                      color: this.colorPairs[0]
                    },
                    {
                      offset: 1,
                      color: this.colorPairs[1]
                    }
                  ],
                  globalCoord: false
                },
              }
            },
            barWidth: 10
          },
          {
            name: "好评率",
            type: "line",
            yAxisIndex: 1,
            data: this.chartData.lineData.valueList,
            symbol: "none",
            itemStyle: {
              normal: {
                opacity: 0.8,
                color: "#ff7352"
              }
            },
            lineStyle: {
              normal: {
                opacity: 0.8,
                color: "#ff7352",
                width: 2
              }
            }
          }
        ]
      };
      this.chart = this.$echarts.init(document.getElementById(this.id));
      this.chart.setOption(this.option);
    }
  }
};
</script>
<style scoped lang="less">
.home-bottom-bar {
  width: 100%;
  height: 100%;
  position: relative;
  .tab-group {
    height: 0.3rem;
    line-height: 0.3rem;
    position: absolute;
    z-index: 999;
    right: 0.15rem;
    top: 0;
    color: @base-text-color;
    > div {
      float: left;
      padding-right: 0.15rem;
      position: relative;
      > div {
        float: left;
      }
      .icon {
        width: 0.3rem;
        height: 0.3rem;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
      .text {
        cursor: pointer;
      }
      ul {
        width: 100%;
        position: absolute;
        left: 0;
        top: 0.3rem;
        li {
          width: 100%;
          height: 0.22rem;
          line-height: 0.22rem;
          border: 1px solid #0c6398;
          background: rgba(0, 183, 247, 0.2);
          cursor: pointer;
        }
      }
    }
  }
}
</style>
